export const qrcode = {
    // Only bg_opa is themed today. Declared here — not the full MAIN_STYLE
    // bundle — purely so the theme's flat bg_opa value keeps reaching the
    // node via config.styles.main; qrcode has no Property Editor style panel
    // and this isn't meant to add one.
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            properties: {
                bg_opa: { type: 'int', min: 0, max: 255, internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled:      { type: 'bool' }, hidden: { type: 'bool' },
        text:         { type: 'string' },
        stretch_mode: {
            type: 'string', internal: true, default: 'keep_ratio',
            options: ['none', 'keep_ratio'],
        },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 40, min_height: 10,
            enabled: true, hidden: false,
            text: 'https://openhasp.com',
        },
    },

    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu', 'keep_ratio'],
    // QR objects are created with delete_event_handler (hasp_object.cpp), not
    // generic_event_handler — every event except delete is immediately ignored, so a
    // press/click produces no HASP event or action dispatch. has_action intentionally omitted.
    runtimeCapabilities: [],

    events: {},
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
